'use client'

import { Spinner } from '@/components/ui/spinner'
import { useMyCIOLanguageOrCookie } from '@/lib/mycio/MyCIOLanguageContext'
import { getMyCIOShellChromeCopy } from '@/lib/mycio/copy/shellChrome'

export function PageLoader() {
  const loading = getMyCIOShellChromeCopy(useMyCIOLanguageOrCookie()).loading
  return (
    <div className="min-h-screen bg-dark-primary flex items-center justify-center">
      <div className="text-center">
        <Spinner size="lg" className="mx-auto mb-4 text-white" />
        <p className="text-dark-text-secondary text-lg">{loading}</p>
      </div>
    </div>
  )
}